import { GlobalWorkerOptions } from "pdfjs-dist";
import workerSrc from "pdfjs-dist/build/pdf.worker.min.mjs?url";

let workerConfigured = false;

export function ensurePdfjsWorker() {
  if (workerConfigured) return;
  GlobalWorkerOptions.workerSrc = workerSrc;
  workerConfigured = true;
}
